import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-cream" data-testid="terms-page">
      <section className="bg-terracotta py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl text-white">Terms & Conditions</h1>
          <p className="font-body text-white/80 mt-2">Last updated: January 2026</p>
        </div>
      </section>
      
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Card className="bg-white rounded-2xl border-none shadow-sm">
            <CardContent className="p-8 md:p-12 space-y-8 font-body text-gray-700 leading-relaxed">
              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Agreement to Terms</h2>
                <p>By accessing and using the Dharma Astra Association website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Use of Website</h2>
                <p>This website is intended for informational purposes about Dharma Astra Association's activities, accepting donations, and volunteer registrations. You agree to use this website only for lawful purposes.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Donations</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>All donations are voluntary and made at the donor's discretion.</li>
                  <li>Donations are used for temple construction, cultural preservation, and social welfare activities.</li>
                  <li>80G tax exemption certificates will be provided for eligible donations as per Indian tax laws.</li>
                  <li>We reserve the right to utilize donations for the organization's overall mission if a specific project is overfunded or discontinued.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Intellectual Property</h2>
                <p>All content on this website, including text, images, logos, and graphics, is the property of Dharma Astra Association and is protected by copyright laws. You may not reproduce, distribute, or use any content without our prior written consent.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Limitation of Liability</h2>
                <p>Dharma Astra Association shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of this website or inability to use our services.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Modifications</h2>
                <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on this website. Continued use of the website constitutes acceptance of modified terms.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Governing Law</h2>
                <p>These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Hyderabad, Telangana.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Contact</h2>
                <p>For questions regarding these Terms & Conditions, contact us at support@dharma-astra.org.</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
